/**
 * MediaStream4U Navigation Hover Effect
 * Handles mouseover/mouseout events for the Mega Menu details element.
 */

document.addEventListener('DOMContentLoaded', () => {
  const detailsElements = document.querySelectorAll('details.mega-menu');

  detailsElements.forEach((details) => {
    // Add hover event listeners
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', 'true');
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });

    // Optional: Add focus/blur for accessibility (or keep default click for keyboard users)
    // For now, we prioritize the mouse hover effect requested.
  });
});
